import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getFullAddressDetails,
  getTernaryValue,
  getDirectionURL,
  checkByParams,
  isAsapOrder,
} from 'common/utilities/utils';
import Strings from '@kfc-global/react-shared/constants/Strings';
import ImageComponent from 'atoms/Image';
import { Link, useHistory } from 'react-router-dom';
import { UserOrderContext } from 'context/context';
import { Col, Container, Row } from 'react-bootstrap';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { Config, OPEN } from 'common/constants/SharedConstants';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { getFacilities } from 'common/utilities/amenities';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import Accordian from 'atoms/Accordian/Accordian';
import {
  addStoreToFavoriteHandler,
  callNearStore,
  collectionPointData,
  formatNumber,
  navigateToMenuPage,
  getRDPIcons,
  getStoreDetails,
  getStoreChannelsDetails,
  removeStoreFromFavoriteHandler,
  isOpenButtonText,
} from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getDayOfWeek, getAvailableHours } from 'common/sharedTemplates/dayHoursTemplates';
import { setASAPOrderStorageData, gotoMenuPage } from 'organisms/SearchStore/AU/Presentation/SearchStoreCardDynamic';
import { getDispositionNewData } from 'organisms/MenusPLP/MenusPlpUtilities/MenuPLPSharedUtils';
const {
  AMENITIES,
  CLOSED_BTN_TEXT,
  GET_DIRECTION,
  TRADING_HRS,
  DELIVERY_HRS,
  KFC_WEB_APP,
  RDP_NO_DELIVERY,
  DELIVERY,
  HOURS,
  CLOSED,
} = TRANSLATE_MAPPING_KEY;
export const getAccordion = (availableHours, title, clickHandler, accordianCnt) => {
  return availableHours?.length > 0 ? (
    <div className='rdp-accordian-container'>
      <Accordian header={title} onClickHandler={clickHandler}>
        {availableHours.map((item, index) => accordianCnt(item))}
      </Accordian>
    </div>
  ) : (
    ''
  );
};
export const startOrderHandler = storeDetailsObj => {
  const {
    storeData,
    enableClickCollectScheduleOrderFlag,
    enableScheduleOrder,
    userOrderStateDispatch,
    goToMenuObj,
    userOrderState,
    enableScheduleOrderFlag,
  } = storeDetailsObj;
  const storeStatus = storeData?.summary?.status?.currentStatus;
  const isStoreOpen = storeStatus === OPEN;
  const isAsapOrderFlag = isAsapOrder(storeData);
  const isSetASAPOrderStorageData = setASAPOrderStorageData(
    enableClickCollectScheduleOrderFlag,
    enableScheduleOrder,
    isStoreOpen,
    isAsapOrderFlag,
  );
  if (isSetASAPOrderStorageData && enableClickCollectScheduleOrderFlag) {
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SET_ORDER_NOW,
      value: { showOrderNow: false },
    });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SET_SCHEDULE_ORDER,
      value: { showScheduleOrder: true },
    });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SET_ASAP_SCHEDULING,
      value: { enableASAPScheduling: true },
    });

    gotoMenuPage(
      userOrderStateDispatch,
      goToMenuObj,
      userOrderState,
      storeData,
      enableScheduleOrderFlag,
      enableClickCollectScheduleOrderFlag,
    );
  } else {
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.DISPOSITION_DATA,
      value: { showDisposition: true },
    });
  }
};

export const deliveryBlock = (rdpPage, showOutboundInRDP, aggregatorData, isMobile, External_url) => {
  return (
    rdpPage.rdpDeliveryBlk &&
    showOutboundInRDP && (
      <div className='delivery-blk'>
        <h2 className='delivery-title'>{translateWithI18Next(DELIVERY)}</h2>
        <div className='separator'></div>
        {aggregatorData && !aggregatorData.length && (
          <div className='delivery-not-available'>{translateWithI18Next(RDP_NO_DELIVERY)}</div>
        )}
        {aggregatorData &&
          aggregatorData.map(item => {
            if (item?.channelName === Config.VIEWPORT_AGENT_BROWSER) {
              return (
                <Link to='/' className='kfc-lockup'>
                  <ImageComponent
                    srcFile={isMobile ? item?.mobileImage : item?.desktopImage}
                    alt={item?.channelName}
                    className='KFCbucket'
                  />
                  <div className='kfc-lockup-cnt'>{translateWithI18Next(KFC_WEB_APP)}</div>
                </Link>
              );
            } else {
              return null;
            }
          })}

        <div className='aggregator-logo-wrap'>
          {aggregatorData &&
            aggregatorData.map(item => {
              if (item?.channelName !== Config.VIEWPORT_AGENT_BROWSER) {
                return (
                  <a
                    href={item?.linkUrl}
                    target='_blank'
                    rel='noreferrer noopener'
                    className={`aggregator-logo ${item?.linkUrl ? 'haslink' : 'nolink'}`}
                  >
                    <div className='aggregator-logo-img'>
                      <ImageComponent
                        srcFile={isMobile ? item?.mobileImage : item?.desktopImage}
                        alt={item?.channelName}
                      />
                    </div>
                    <div className='aggregator-url'>
                      {item?.channelName}
                      <ImageComponent srcFile={External_url} alt={'External url'} className='' />
                    </div>
                  </a>
                );
              } else {
                return null;
              }
            })}
        </div>
      </div>
    )
  );
};

const RestaurantDetailsView = props => {
  const { StripsIcon, FavoriteFillImage, FavoriteUnfillImage, phoneImg, External_url, Direction } = IMAGE_PATH;
  const { loggedIn, restarantDetails, restrauntContentful, isMobile, storeNumberFormat } = props;
  const { favouriteStores } = useSelector(data => data?.profileReducer);
  const userParams = useSelector(data => data?.appStateReducer?.userStatus || {});
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const history = useHistory();

  const favIdList = favouriteStores?.map(item => item?.storeBasic?.id);
  const storeData = favIdList?.includes(restarantDetails?.id)
    ? { ...restarantDetails, isFavoriteStore: true }
    : restarantDetails;
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  const tenantReducer = useSelector(data => data.tenantReducer);
  const dispositionNew = getDispositionNewData(userOrderState);
  const enableClickCollectScheduleOrder =
    tenantReducer?.componentOptions?.web?.dispositionConfig?.enableClickCollectScheduleOrder;
  const enableScheduleOrder = tenantReducer?.componentOptions?.web?.dispositionConfig?.enableScheduleOrder;
  const showOutboundInRDP = tenantReducer?.componentOptions?.web?.dispositionConfig?.showOutboundInRDP;
  const allowScheduleOrderForDispositions =
    tenantReducer?.componentOptions?.web?.scheduledDelivery?.allowScheduleOrderForDispositions;
  const enableClickCollectScheduleOrderFlag =
    enableClickCollectScheduleOrder && allowScheduleOrderForDispositions?.includes(dispositionNew?.type?.toLowerCase());
  const enableScheduleOrderFlag = enableScheduleOrder || enableClickCollectScheduleOrderFlag;
  const gotoMenuPage = () => {
    navigateToMenuPage(userOrderStateDispatch, history, dispatch, {
      tenantId,
      userParams,
      userOrderState,
      store: storeData,
    });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.FAV_STORE_NOT_IN_RADIUS,
      value: { showNotInRadiusError: false },
    });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.ORDER_MODE_BROWSE_MENU_CLICK,
      value: { orderModeBrowseMenuBtnClicked: true },
    });
  };

  let getStore = storeData && Object.keys(storeData).length && getStoreDetails(storeData, true);
  const aggregatorData =
    storeData &&
    Object.keys(storeData).length &&
    getRDPIcons(restrauntContentful?.details?.fields?.icons, storeData?.availableServicesPerChannel);
  const collectionPoint =
    storeData && Object.keys(storeData).length && collectionPointData(storeData?.availableCollectionPoints);

  const dispatch = useDispatch();
  const { customerId } = useSelector(data => data?.profileReducer);
  const {
    tenantId,
    componentOptions: {
      web: { rdpPage },
    },
  } = useSelector(data => data?.tenantReducer);
  const goToMenuObj = { history, dispatch, tenantId, userParams };
  const onClickHandler = e => {
    const accordian = e.target.parentElement.parentElement.parentElement;
    accordian.classList.contains('rdp-accordian-open')
      ? accordian.classList.remove('rdp-accordian-open')
      : accordian.classList.add('rdp-accordian-open');
  };
  const storeDetailsObj = {
    storeData,
    enableClickCollectScheduleOrderFlag,
    enableScheduleOrder,
    userOrderStateDispatch,
    goToMenuObj,
    userOrderState,
    enableScheduleOrderFlag,
  };

  const accordianCnt = item => {
    return (
      <div key={item?.day} className='hours-view'>
        <div className='hours-text'>
          <span className='day-details'>{getDayOfWeek(item)}</span>
          <span className='time-details'>
            <p>{getAvailableHours(item)}</p>
          </span>
        </div>
      </div>
    );
  };
  return (
    <Container className='retaurant-view-container'>
      <div className='strips-Icon'>
        <ImageComponent srcFile={StripsIcon} alt={'stripsIcon'} />
      </div>
      <div className='fav-icon'>
        {loggedIn && (
          <ImageComponent
            data-testid='favorite-img'
            srcFile={getTernaryValue(storeData?.isFavoriteStore, FavoriteFillImage, FavoriteUnfillImage)}
            alt={'favorite'}
            className='favorite-img'
            onClick={() =>
              getTernaryValue(
                storeData?.isFavoriteStore,
                removeStoreFromFavoriteHandler(storeData, dispatch, tenantId, customerId),
                addStoreToFavoriteHandler(storeData, dispatch, tenantId, customerId),
              )
            }
          />
        )}
      </div>
      <Row className='restraunt-detail-wrapper'>
        {rdpPage.rdpAddress && (
          <Col md='5' className='restraunt-detail-addr'>
            <h1 className='store-name-rdp'>{storeData?.name?.[0]?.value}</h1>
            <div className='store-address'>{getFullAddressDetails(storeData?.addresses?.[0]?.address)}</div>
            <div className='store-channel-details'>{getStoreChannelsDetails(storeData, collectionPoint)}</div>
            <div className='store-contact-wrapper'>
              {callNearStore(storeData) && (
                <div className='mt15 store-contact'>
                  <span className='contact-icon'>
                    <ImageComponent srcFile={phoneImg} alt='℡' />
                  </span>
                  <a
                    data-testid='store-number'
                    href={`${Strings.tel}${callNearStore(storeData)}`}
                    className='contact-info ml-2'
                  >
                    {formatNumber(callNearStore(storeData), storeNumberFormat)}
                  </a>
                </div>
              )}
              <a href={getDirectionURL(getStore?.storeAddress)} target='_blank' rel='noreferrer noopener'>
                <span className='kfcdirection'>
                  <img src={Direction} alt='direction' className='KfcDirectionIcon' />
                  <span>{translateWithI18Next(GET_DIRECTION)}</span>
                </span>
              </a>
            </div>
            {checkByParams(
              storeData?.summary,
              <ContainedButton
                data-testid='start-order'
                variant={getTernaryValue(getStore?.storeOpen, ButtonType.primary, ButtonType.tertiary)}
                onClickHandler={event => (getStore?.storeOpen ? startOrderHandler(storeDetailsObj) : gotoMenuPage())}
              >
                {isOpenButtonText(true, getStore?.storeOpen)}
              </ContainedButton>,
            )}
          </Col>
        )}
        <Col md='7' className='restraunt-detail-cnt'>
          {/* Hours Block */}
          {rdpPage.rdpHrsblock && (
            <div className='hour-blk-wrapper'>
              <div className='hour-blk'>
                <h2 className='hour-title'>{translateWithI18Next(HOURS)}</h2>
                <div className='opening-hrs'>
                  {checkByParams(storeData?.summary, <span>{getStore?.storeTimeMessage}</span>)}
                  {checkByParams(!storeData?.summary, <span class='closed-text'>{translateWithI18Next(CLOSED)}</span>)}
                </div>
              </div>
              <div className='accordian-blk'>
                {getAccordion(
                  storeData?.availableTradingHours,
                  translateWithI18Next(TRADING_HRS),
                  onClickHandler,
                  accordianCnt,
                )}
                {getAccordion(
                  storeData?.availableDeliveryHours,
                  translateWithI18Next(DELIVERY_HRS),
                  onClickHandler,
                  accordianCnt,
                )}
              </div>
            </div>
          )}

          {/* Amenities Block */}
          {!!storeData?.amenities?.length && rdpPage.rdpAmenitiesBlk && (
            <div className='amenities-blk'>
              <h3 className='amenities-title'>{translateWithI18Next(AMENITIES)}</h3>
              <div className='separator'></div>
              <div className='amenities-cnt'>
                <ul className='amenities-list-wrapper'>
                  {getFacilities(storeData, 'rdp')?.map(item => {
                    return (
                      <li className='amenities-list'>
                        <ImageComponent
                          key={item?.key}
                          data-testid=''
                          srcFile={item?.image}
                          alt={item?.label}
                          className='amenities-img'
                          title={item?.label}
                        />
                        {getTernaryValue(item?.label, item?.label, item?.key)}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}

          {/* Delivery Block */}
          {deliveryBlock(rdpPage, showOutboundInRDP, aggregatorData, isMobile, External_url)}
        </Col>
      </Row>
    </Container>
  );
};

const RestaurantDetailsViewSection = React.memo(RestaurantDetailsView);
export default RestaurantDetailsViewSection;
